import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'src/app/tasklist/single/tasklist-single.component';
import { AvailableTemplatesService, GetAvailableTemplatesRequest } from '../available-templates.service';
import { AlertSettingsVariable, PagedAlertSettingsVariablesResponse } from 'src/app/hickory-api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { FormControl } from '@angular/forms';
import { catchError, debounceTime, merge, of, startWith, switchMap, tap } from 'rxjs';
import { AlertModelService } from 'src/app/alert/shared/alert-model';

export interface PagingConfig {
  searchTerm?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  direction?: SortDirection;
}

@Component({
  selector: 'app-available-templates-dialog',
  templateUrl: './available-templates-dialog.component.html',
  styleUrl: './available-templates-dialog.component.scss',
  standalone: false
})
export class AvailableTemplatesDialogComponent implements AfterViewInit {
  dataSource: AlertSettingsVariable[] = [];
  displayedColumns: string[] = ['friendlyname', 'placeholder', 'sampleValue', 'source', 'maxlength'];

  isLoadingResults = true;
  resultLength = 0;

  pagingConfig: PagingConfig = {
    searchTerm: '',
    page: 1,
    pageSize: 5,
    sort: 'placeholder',
    direction: 'asc'
  };

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  filterControl = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<AvailableTemplatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly variablesService: AvailableTemplatesService,
    public alertModel: AlertModelService
  ) {}

  ngAfterViewInit(): void {
    const sortChanges = this.sort.sortChange.pipe(
      tap(() => this.paginator.pageIndex = 0)
    );

    const filterChanges = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      tap(() => this.paginator.pageIndex = 0)
    );

    merge(sortChanges, filterChanges, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          // Update paging config
          this.pagingConfig.page = this.paginator.pageIndex + 1;
          this.pagingConfig.sort = this.sort.active || 'placeholder';
          this.pagingConfig.direction = this.sort.direction || 'asc';
          this.pagingConfig.searchTerm = this.filterControl.value || '';

          const request: GetAvailableTemplatesRequest = {
            page: this.pagingConfig.page,
            sort: this.pagingConfig.direction == 'desc' ? `-${this.pagingConfig.sort}` : this.pagingConfig.sort,
            searchTerm: this.pagingConfig.searchTerm,
            pageSize: this.pagingConfig.pageSize,
            alertTemplateId: this.alertModel?.alertTemplate?.id
          }

          return this.variablesService.getAvailableTemplates(this.alertModel?.alertTemplate?.id, request);
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return of([]);
        }),
      )
      .subscribe((result: PagedAlertSettingsVariablesResponse) => {
        this.dataSource = result.items;
        this.resultLength = result.totalItemCount;
        this.isLoadingResults = false;
      });
  }
}
